import React from "react";
import "./Dalbergia.scss";
import data from "./data.json";
import Card from "../../Component/Card Viola/cardviola";
import Serissaimages from "../../Media/CGB/Dalbergia/Serissa/Serissa";
import Sennaimages from "../../Media/CGB/Dalbergia/Serissa/Serissa";
import Magnoliaimages from "../../Media/CGB/Calamus/Magnolia/Magnolia";
const imageMap = {
  Serissaimages,
  Sennaimages,
  Magnoliaimages,
  // Add other image arrays here if you have more sets
};

const produk = () => {
  return (
    <div id="dalbergia" className="Dalbergia">
      <h1>Cluster Dalbergia</h1>
      <h2>Cicilan Start From 7 Juta/Bulan</h2>
      <div className="cardhome-containercalamus">
        {data.cards.map((card, index) => {
          // Determine the logo dynamically
          // Determine the logo dynamically
          return (
            <Card
              key={index}
              carousel={imageMap[card.imagesKey]}
              title={card.title}
              subtitle={card.subtitle}
              price={card.price}
              subprice={card.subprice}
              details={card.details}
              whatsappLink={card.whatsappLink} // Pass the WhatsApp link
            />
          );
        })}
      </div>
    </div>
  );
};

export default produk;
